import { call, put, select, take, takeLatest } from "redux-saga/effects";
import { MasterAPI } from "services/master";
import { CustomerAPI } from "services/customer";
import { RegisterAPI } from "services/register";
import { getRoutePath, Routes } from "const/routes";
import { push, goBack, go } from "connected-react-router";

import {
  searchQuestion,
  searchQuestionSuccess,
  searchQuestionFailure,
  getInitInfoRegister,
  getInitInfoRegisterSuccess,
  getInitInfoRegisterFailure,
  onRegister,
  onRegisterSuccess,
  onRegisterFailure,
  onSubmitSuitability,
  onSubmitSuitabilitySuccess,
  onSubmitSuitabilityFailure,
  onSubmitRiskResult,
  onUpdateProfile,
  onUpdateProfileSuccess,
  onUpdateProfileFailure,
  getProfileCBS,
  pageDirect,
} from "redux/reducers/register";

import {
  getLookupRegisterForm,
  getLookupRegisterFormSuccess,
  getLookupRegisterFormFailure,
  getProvinceListSuccess,
  fetchBrokerListSuccess,
} from "redux/reducers/master";
import { getAddressCompact } from "./master";
import { setRegisteredStatus, setSuitabilityResult } from "redux/reducers/customer";
import { checkRiskProfile } from "./customer";
import { redirect } from "redux/reducers/redirect";
import { RedirectSelector } from "redux/selector/redirect-selector";
import { validInvestorProperties } from "redux/reducers/disclaimer";
import { RiskProfileError } from "classes/error/RiskProfileError";
import { handleClientError } from "utils/saga-error";
import { openModal } from "redux/reducers/central-modal";
import { RiskProfileErrors } from "const";
import { createLocationChangeChannel } from "./redirect";
import { RouterPageStackSelector } from "redux/selector/router-page-stack-selector";
import { isMissingTaxIdError } from "const/const-helper";

function* searchQuerySaga() {
  try {
    const response = yield call(MasterAPI.getQuestion);
    yield put(searchQuestionSuccess(response.data.result));
  } catch (error) {
    yield put(searchQuestionFailure(error));
  }
}

function* getInitInfoRegisterSaga() {
  try {
    const resDefaultRegister = yield call(MasterAPI.getLookupRegisterForm);
    const {
      listOfOccupation,
      listOfProvince,
      listOfReceiveMethod,
      listOfBranch,
      listOfBroker,
      listOfIncomeSource,
      listOfChannel,
      listOfReceiveBenefits,
    } = resDefaultRegister.data;
    yield put(
      getLookupRegisterFormSuccess({
        listOfOccupation,
        // listOfProvince,
        listOfReceiveMethod,
        listOfBranch,
        listOfIncomeSource: listOfIncomeSource.filter((i) => (typeof i.customer === "boolean" ? i.customer : true)),
        listOfChannel,
        listOfReceiveBenefits,
      }),
    );
    yield put(getProvinceListSuccess(listOfProvince));
    yield put(fetchBrokerListSuccess(listOfBroker));

    const responseCustomer = yield call(CustomerAPI.getCustomerProfileMNC);
    const customerInfo = responseCustomer.data.result;
    const responseDefault = yield call(RegisterAPI.getDefault);

    let resDefaultMaster = responseDefault.data.result;
    if (resDefaultMaster.mailingProvince && resDefaultMaster.mailingDistrict && resDefaultMaster.mailingSubDistrict) {
      let addressCbsTxt = yield call(
        getAddressCompact,
        resDefaultMaster.mailingProvince,
        resDefaultMaster.mailingDistrict,
        resDefaultMaster.mailingSubDistrict,
      );
      resDefaultMaster = {
        ...resDefaultMaster,
        mailingProvinceTxt: addressCbsTxt[0],
        mailingDistrictTxt: addressCbsTxt[1],
        mailingSubDistrictTxt: addressCbsTxt[2],
      };
    }

    yield put(getProfileCBS(resDefaultMaster));

    let info = {};

    if (customerInfo) {
      info.email = customerInfo.email ? customerInfo.email : resDefaultMaster.email;
      info.mobile = customerInfo.mobile ? customerInfo.mobile : resDefaultMaster.mobile;
      info.incomeSource = customerInfo.incomeSource
        ? customerInfo.incomeSource
          ? customerInfo.incomeSource.split("|")
          : null
        : resDefaultMaster.incomeSource
          ? resDefaultMaster.incomeSource.split("|")
          : null;
      info.incomeSourceOthDesc = customerInfo.incomeSourceOthDesc
        ? customerInfo.incomeSourceOthDesc
        : resDefaultMaster.incomeSourceOthDesc;
      info.occupation = customerInfo.occupation ? customerInfo.occupation : resDefaultMaster.occupation;
      info.receiveMethod = customerInfo.receiveMethod ? customerInfo.receiveMethod : resDefaultMaster.receiveMethod;
      info.receiveSecurityCompanyCode = customerInfo.receiveSecuritiesCompanyCode
        ? customerInfo.receiveSecuritiesCompanyCode
        : resDefaultMaster.receiveSecurityCompanyCode;
      info.receiveAccountNumber = customerInfo.receiveAccountNumber
        ? customerInfo.receiveAccountNumber
        : resDefaultMaster.receiveAccountNumber;
      info.mailingAddress = customerInfo.mailingAddress ? customerInfo.mailingAddress : resDefaultMaster.mailingAddress;
      info.mailingProvince = customerInfo.mailingProvince
        ? customerInfo.mailingProvince
        : resDefaultMaster.mailingProvince;
      info.mailingDistrict = customerInfo.mailingDistrict
        ? customerInfo.mailingDistrict
        : resDefaultMaster.mailingDistrict;
      info.mailingSubDistrict = customerInfo.mailingSubDistrict
        ? customerInfo.mailingSubDistrict
        : resDefaultMaster.mailingSubDistrict;
      info.mailingZipCode = customerInfo.mailingZipCode ? customerInfo.mailingZipCode : resDefaultMaster.mailingZipCode;
      info.channel = customerInfo.channel ? customerInfo.channel : resDefaultMaster.channel;
      info.channelBrn = customerInfo.channelBrn ? customerInfo.channelBrn : resDefaultMaster.channelBrn;
      info.channelOther = customerInfo.channelOther ? customerInfo.channelOther : resDefaultMaster.channelOther;
      info.nationality = customerInfo.nationality ? customerInfo.nationality : resDefaultMaster.nationality;
      info.taxId = customerInfo.taxId ? customerInfo.taxId : resDefaultMaster.taxId;
    } else {
      info = resDefaultMaster;
    }
    let addressTxt = [];
    try {
      addressTxt = yield call(getAddressCompact, info.mailingProvince, info.mailingDistrict, info.mailingSubDistrict);
    } catch (error) {
      console.error("Get Address Error", error);
    }
    yield put(
      getInitInfoRegisterSuccess({
        ...info,
        mailingProvinceTxt: addressTxt[0],
        mailingDistrictTxt: addressTxt[1],
        mailingSubDistrictTxt: addressTxt[2],
      }),
    );
  } catch (error) {
    //* tax id validation
    if (isMissingTaxIdError(error?.code)) {
      error.ignore = true;
    }

    yield put(getLookupRegisterFormFailure(error));
    yield put(getInitInfoRegisterFailure(error));
  }
  return false;
}

function* onRegisterSaga(action) {
  try {
    let req = action.payload;
    req.incomeSource = req.incomeSource ? req.incomeSource.join("|") : null;

    const response = yield call(RegisterAPI.register, req);
    yield put(onRegisterSuccess(response));
    //render if End register
    const data = (yield select(RedirectSelector.state))["register"];
    if (data) {
      yield put(redirect("register"));
    } else {
      const validSuitability = yield call(checkRiskProfile);
      if (validSuitability) {
        yield put(validInvestorProperties());
        yield put(push(getRoutePath(Routes.Register.RiskResult)));
      } else {
        yield put(pageDirect("register"));
        yield put(push(getRoutePath(Routes.Register.Suitability)));
      }
    }
    yield put(setRegisteredStatus(true));
  } catch (error) {
    if (error instanceof RiskProfileError) {
      yield put(openModal({ code: RiskProfileErrors.SystemNotReady }));
    } else {
      yield put(onRegisterFailure(handleClientError(error)));
    }
  }
}

function* onUpdateProfileSaga(action) {
  try {
    let req = action.payload;
    const redirectBack = !!action.payload?.redirectBack;

    req.incomeSource = req.incomeSource ? req.incomeSource.join("|") : null;
    const response = yield call(RegisterAPI.updateProfile, req);
    yield put(onUpdateProfileSuccess(response));
    //render if End register
    if (redirectBack) {
      yield put(goBack());
      return;
    }
    const data = (yield select(RedirectSelector.state))["register"];
    if (data) {
      yield put(redirect("register"));
    } else {
      const validSuitability = yield call(checkRiskProfile);
      if (validSuitability) {
        yield put(push(getRoutePath(Routes.Register.RiskResult)));
      } else {
        yield put(push(getRoutePath(Routes.Register.Suitability)));
      }
    }
  } catch (error) {
    if (error instanceof RiskProfileError) {
      yield put(openModal({ code: RiskProfileErrors.SystemNotReady }));
    } else {
      yield put(onUpdateProfileFailure(handleClientError(error)));
    }
  }
}

function* onSubmitSuitabilitySaga(action) {
  try {
    let listOfAnswers = action.payload;
    const response = yield call(CustomerAPI.sendSuitabilityTest, { listOfAnswers });

    yield put(onSubmitSuitabilitySuccess(response));
    yield put(setSuitabilityResult(true));
    yield put(validInvestorProperties());
    yield put(push(getRoutePath(Routes.Register.RiskResult)));
  } catch (error) {
    yield put(onSubmitSuitabilityFailure(error));
  }
}

function* onSubmitRiskResultSaga() {
  try {
    const locationChangeChannel = yield call(createLocationChangeChannel);
    const pageStack = yield select(RouterPageStackSelector.pageStack);
    yield put(pageDirect(""));

    // clear out history stack for suit test pages
    if (pageStack > 2) {
      yield put(go(-2)); // clear 2 pages
      yield take(locationChangeChannel); // wait go back history stack end
    } else {
      const canBack = -(pageStack - 1);
      if (canBack < 0) {
        yield put(go(canBack));
        yield take(locationChangeChannel); // wait go back history stack end
      }
    }

    yield put(redirect("suitability"));

    try {
      //* clean up channel
      locationChangeChannel.close();
    } catch (_) {}
  } catch (error) {
    console.log(error);
  }
}

const saga = [
  takeLatest(searchQuestion.type, searchQuerySaga),
  takeLatest(onRegister.type, onRegisterSaga),
  takeLatest(onUpdateProfile.type, onUpdateProfileSaga),
  takeLatest(getInitInfoRegister.type, getInitInfoRegisterSaga),
  takeLatest(getLookupRegisterForm.type, getInitInfoRegisterSaga),
  takeLatest(onSubmitSuitability.type, onSubmitSuitabilitySaga),
  takeLatest(onSubmitRiskResult.type, onSubmitRiskResultSaga),
];

export default saga;
